import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto, GalleryGroupAccessLevel, GroupDto } from '@nusign/picflow-backend-types';
import { filter, map, switchMap } from 'rxjs';
import { UserGroupService } from '../../../services/user-group.service';
import { GalleryShareContextComponent } from '../../../shared-extra/components/gallery-share-context/gallery-share-context.component';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-gallery-user-group-access-item',
  imports: [
    GalleryShareContextComponent,
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemBodyComponent,
    AccessItemCtaComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-user-group-access-item.component.html',
  styleUrl: './gallery-user-group-access-item.component.scss',
})
export class GalleryUserGroupAccessItemComponent {
  private userGroupService = inject(UserGroupService);
  gallery = input.required<GalleryDto>();
  group = input.required<GroupDto>();
  groupAccessLevel = input.required<GalleryGroupAccessLevel>();
  galleryPermissions = input.required<GalleryDto['permissions']>();
  groupAccessLevels: GalleryGroupAccessLevel[] = ['edit', 'review', 'view_only'];
  groupUserCount = toSignal(
    toObservable(this.group).pipe(
      filter(Boolean),
      switchMap(group => this.userGroupService.getUserGroupUsers(group.id).pipe(map(users => users.length)))
    )
  );

  changeGroupAccessLevel(accessLevel: GalleryGroupAccessLevel) {
    this.userGroupService
      .updateGalleryUserGroupAccessLevel(this.group().id, this.gallery().id, accessLevel)
      .subscribe();
  }
}
